// DESCRIPTION: Selectable card used for business-type and payment-method
// choices. Renders a title + description with an accented selected state.

/**
 * A selectable card with a title and helper description.
 *
 * @since PBOOKING_SINCE
 *
 * @param {Object}   props
 * @param {string}   props.title
 * @param {string}   [props.description]
 * @param {boolean}  props.isActive
 * @param {Function} props.onClick
 *
 * @return {JSX.Element}
 */
export default function ChoiceCard( {
	title,
	description,
	isActive,
	onClick,
} ) {
	return (
		<button
			type="button"
			className={ `nemtly-wizard-choice ${
				isActive ? 'is-active' : ''
			}` }
			onClick={ onClick }
			aria-pressed={ isActive }
		>
			<span className="nemtly-wizard-choice__title">{ title }</span>
			{ description && (
				<span className="nemtly-wizard-choice__desc">
					{ description }
				</span>
			) }
		</button>
	);
}
